import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import LoadingSpinner from '../components/common/LoadingSpinner';
import ErrorMessage from '../components/common/ErrorMessage';
import EmptyState from '../components/common/EmptyState';
import { getErrorMessage } from '../utils/api';

const JobPostSection = () => {
    const [jobPostData, setJobPostData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchJobPosts = useCallback(async () => {
        setLoading(true);
        setError(null);
        const url = `${process.env.REACT_APP_API_URI}/JobPost`;

        try {
            const response = await axios.get(url);
            // Handle both response.data array or nested response.data.data
            const data = response.data?.data !== undefined ? response.data.data : response.data;
            if (Array.isArray(data)) {
                setJobPostData(data);
            } else {
                setJobPostData([]);
            }
        } catch (err) {
            console.error('Error fetching job posts:', err);
            setError(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchJobPosts();
    }, [fetchJobPosts]);

    return (
        <div className="row">
            {/* 1. Loading State */}
            {loading && (
                <div className="col-12">
                    <LoadingSpinner message="Fetching latest job posts..." />
                </div>
            )}

            {/* 2. Error State */}
            {!loading && error && (
                <div className="col-12">
                    <ErrorMessage message={error} onRetry={fetchJobPosts} />
                </div>
            )}

            {/* 3. Empty / Not Found State */}
            {!loading && !error && jobPostData.length === 0 && (
                <div className="col-12">
                    <EmptyState
                        title="No Job Posts Found"
                        message="There are currently no job openings matching this criteria. Please check back later."
                        icon="fa-briefcase"
                    />
                </div>
            )}

            {/* 4. Success State */}
            {!loading && !error && jobPostData.length > 0 && (
                jobPostData.map(item => (
                    <div className="col-lg-12 col-md-12" key={item.id || item.title}>
                        <div className="featured-imagebox featured-imagebox-job bg-theme-GreyColor">
                            <div className="featured-thumbnail">
                                <img
                                    src={`${process.env.REACT_APP_ASSET_URL}/${item.company_logo}`}
                                    alt={item.title || 'Job Logo'}
                                    onError={(e) => {
                                        // Fallback if image fails to load
                                        e.target.onerror = null;
                                        e.target.src = `${process.env.PUBLIC_URL}/images/job-placeholder.png`;
                                    }}
                                />
                            </div>
                            <div className="featured-content">
                                <div className="featured-title">
                                    <h3>
                                        <a href={process.env.PUBLIC_URL + '/Job_details'}>
                                            {item.title}
                                        </a>
                                    </h3>
                                </div>
                                <div className="featured-desc">
                                    <p>{item.category}</p>
                                    <p><strong>LastDate: </strong> <span>{item.closing_at}</span></p>
                                </div>
                                <div className="featured-bottom">
                                    <div className="job-meta">
                                        <span><i className="fa fa-map-marker-alt"></i>{item.location}</span>
                                        <span><i className="fa fa-filter"></i>{item.company_name}</span>
                                        <span><i className="fa fa-envelope"></i> {item.Email}</span>
                                    </div>
                                    <div className="job-time">
                                        <span className="green">{item.shift}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default JobPostSection;